// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* UploadImages */

.gZKjJSbC1dyyLYR94xxJ {
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	flex-wrap: wrap;
	width: 100%;
	gap: 10px;
}

.pE1xz1z1E9rKuSNyO9nV, .vOprg0DvxXjQslT_3vJL {
	position: relative;
	display: flex;
    justify-content: center;
    align-items: center;
	width: 80px;
	height: 80px;
	border: 1px solid #b1b0b0;
	background-color: #BED4DB;
	border-radius: 3px;
	cursor: pointer;
	transition: scale 0.3s, box-shadow 0.3s;
}

.pE1xz1z1E9rKuSNyO9nV:hover, .vOprg0DvxXjQslT_3vJL:hover {
	scale: 1.03;
	box-shadow: 0px 0px 6px 2px rgb(0 0 0 / 10%);
}

.pE1xz1z1E9rKuSNyO9nV:active, .vOprg0DvxXjQslT_3vJL:active {
	scale: 0.99;
	box-shadow: unset
}

.pE1xz1z1E9rKuSNyO9nV > img {
	width: 100%;
	-o-object-fit: cover;
	   object-fit: cover;
}

/* Close */
.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx {
	display: flex;
	position: absolute;
	top: 0;
	right: 0;
	justify-content: center;
	align-items: center;
	width: 20px;
	height: 20px;
	cursor: pointer;
	opacity: 0.7;
	transition: transform 0.3s, opacity 0.3s;
}

.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx::before, .pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx::after {
	content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 3px;
    background-color: #1D1D1B;
}

.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx::before {
	transform: rotate(45deg);
}

.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx::after {
	transform: rotate(-45deg);
}

.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx:focus {
	background-color: red;
	width: 100%;
	height: 100%;
	transition: width 0.1s, height 0.3s;
}

.pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx:focus::before, .pE1xz1z1E9rKuSNyO9nV .aMqtUEZW0XHUy_DOYJLx:focus::after {
	background-color: #FFFFFF;
}

.vOprg0DvxXjQslT_3vJL {
	display: flex;
	justify-content: center;
	align-items: center;
}

.vOprg0DvxXjQslT_3vJL::after {
	content: "+";
	font-size: 1.9em;
	color: #777777;
}

.OzAwQ6ShOpnlEJAa3aoy {
	display: flex;
	position: absolute;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	-webkit-backdrop-filter: blur(2px);
	        backdrop-filter: blur(2px);
	background-color: #BED4DB9F;
	z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/UploadImages/style.module.css"],"names":[],"mappings":"AAAA,iBAAiB;;AAEjB;CACC,aAAa;CACb,mBAAmB;CACnB,2BAA2B;CAC3B,eAAe;CACf,WAAW;CACX,SAAS;AACV;;AAEA;CACC,kBAAkB;CAClB,aAAa;IACV,uBAAuB;IACvB,mBAAmB;CACtB,WAAW;CACX,YAAY;CACZ,yBAAyB;CACzB,yBAAyB;CACzB,kBAAkB;CAClB,eAAe;CACf,uCAAuC;AACxC;;AAEA;CACC,WAAW;CACX,4CAA4C;AAC7C;;AAEA;CACC,WAAW;CACX;AACD;;AAEA;CACC,WAAW;CACX,oBAAiB;IAAjB,iBAAiB;AAClB;;AAEA,UAAU;AACV;CACC,aAAa;CACb,kBAAkB;CAClB,MAAM;CACN,QAAQ;CACR,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,wCAAwC;AACzC;;AAEA;CACC,WAAW;IACR,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,yBAAyB;AAC7B;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,qBAAqB;CACrB,WAAW;CACX,YAAY;CACZ,mCAAmC;AACpC;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,MAAM;CACN,OAAO;CACP,kCAA0B;SAA1B,0BAA0B;CAC1B,2BAA2B;CAC3B,UAAU;AACX","sourcesContent":["/* UploadImages */\r\n\r\n.container {\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: flex-start;\r\n\tflex-wrap: wrap;\r\n\twidth: 100%;\r\n\tgap: 10px;\r\n}\r\n\r\n.image, .new {\r\n\tposition: relative;\r\n\tdisplay: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n\twidth: 80px;\r\n\theight: 80px;\r\n\tborder: 1px solid #b1b0b0;\r\n\tbackground-color: #BED4DB;\r\n\tborder-radius: 3px;\r\n\tcursor: pointer;\r\n\ttransition: scale 0.3s, box-shadow 0.3s;\r\n}\r\n\r\n.image:hover, .new:hover {\r\n\tscale: 1.03;\r\n\tbox-shadow: 0px 0px 6px 2px rgb(0 0 0 / 10%);\r\n}\r\n\r\n.image:active, .new:active {\r\n\tscale: 0.99;\r\n\tbox-shadow: unset\r\n}\r\n\r\n.image > img {\r\n\twidth: 100%;\r\n\tobject-fit: cover;\r\n}\r\n\r\n/* Close */\r\n.image .close {\r\n\tdisplay: flex;\r\n\tposition: absolute;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: 20px;\r\n\theight: 20px;\r\n\tcursor: pointer;\r\n\topacity: 0.7;\r\n\ttransition: transform 0.3s, opacity 0.3s;\r\n}\r\n\r\n.image .close::before, .image .close::after {\r\n\tcontent: \"\";\r\n    display: block;\r\n    position: absolute;\r\n    width: 100%;\r\n    height: 3px;\r\n    background-color: #1D1D1B;\r\n}\r\n\r\n.image .close::before {\r\n\ttransform: rotate(45deg);\r\n}\r\n\r\n.image .close::after {\r\n\ttransform: rotate(-45deg);\r\n}\r\n\r\n.image .close:focus {\r\n\tbackground-color: red;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttransition: width 0.1s, height 0.3s;\r\n}\r\n\r\n.image .close:focus::before, .image .close:focus::after {\r\n\tbackground-color: #FFFFFF;\r\n}\r\n\r\n.new {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}\r\n\r\n.new::after {\r\n\tcontent: \"+\";\r\n\tfont-size: 1.9em;\r\n\tcolor: #777777;\r\n}\r\n\r\n.wait {\r\n\tdisplay: flex;\r\n\tposition: absolute;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\twidth: 100%;\r\n\theight: 100%;\r\n\ttop: 0;\r\n\tleft: 0;\r\n\tbackdrop-filter: blur(2px);\r\n\tbackground-color: #BED4DB9F;\r\n\tz-index: 1;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `gZKjJSbC1dyyLYR94xxJ`,
	"image": `pE1xz1z1E9rKuSNyO9nV`,
	"new": `vOprg0DvxXjQslT_3vJL`,
	"close": `aMqtUEZW0XHUy_DOYJLx`,
	"wait": `OzAwQ6ShOpnlEJAa3aoy`
};
export default ___CSS_LOADER_EXPORT___;
